import { render } from "./ListData.vue?vue&type=template&id=675669d1"
import script from "./ListData.vue?vue&type=script&lang=js"
export * from "./ListData.vue?vue&type=script&lang=js"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__